// Copied from https://office.visualstudio.com/Office/_git/1JS?path=/midgard/packages/scc-types/src/app/UserCohort.ts
export enum UserCohort {
    Unknown = 'unknown',
    None = 'none',
    BCAIS = 'bcais', // BizChat - AI SKU users
    BCWAF = 'bcwaf', // BizChat Web - All Features
    BCWBF = 'bcwbf', // BizChat Web - Basic Features
}
